export default __webpack_public_path__ + "static/media/hazard_map_MAR.7572c892.jpg";